import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DocumentPickerState, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, StepperTypeTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../../routes';
import { ACTION } from './types';
import { getCoBorrowerName, horizontalStepperRepo, } from '../../../../configs/utils';
import { documentPickerAction, GoBackAction, onPageLoad, triggerAction, } from './actions';
import SharedPropsService from '../../../../SharedPropsService';
export const template = (stepper, fullName) => {
    return {
        layout: {
            id: ROUTE.CO_BORROWER_DOCUMENTS_UPLOAD_POA_MANUAL,
            type: LAYOUTS.LIST,
            widgets: [
                {
                    id: 'header',
                    type: WIDGET.HEADER,
                    position: POSITION.ABSOLUTE_TOP,
                },
                { id: 'topSpace', type: WIDGET.SPACE },
                { id: 'userDetails', type: WIDGET.STACK },
                { id: 'spaceBeforeTitle', type: WIDGET.SPACE },
                { id: 'title', type: WIDGET.TEXT },
                { id: 'spaceSubTitle', type: WIDGET.SPACE },
                { id: 'subTitle', type: WIDGET.TEXT },
                { id: 'spaceSecondarySubTitle', type: WIDGET.SPACE },
                { id: 'secondarySubTitle', type: WIDGET.TEXT },
                { id: 'subTitleSpace', type: WIDGET.SPACE },
                { id: 'dropDownSpace', type: WIDGET.SPACE },
                { id: 'frontSide', type: WIDGET.DOCUMENT_PICKER },
                { id: 'frontSideSpace', type: WIDGET.SPACE },
                { id: 'backSide', type: WIDGET.DOCUMENT_PICKER },
                {
                    id: 'stackBottom',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_BOTTOM,
                },
            ],
        },
        datastore: {
            topSpace: { size: SizeTypeTokens.MD },
            dropDownSpace: { size: SizeTypeTokens.XXXL },
            frontSide: {
                titleLabel: 'Front side',
                ctaLabel: 'Upload',
                state: DocumentPickerState.DEFAULT,
                action: {
                    type: ACTION.SELECT_DOCUMENT,
                    routeId: ROUTE.CO_BORROWER_DOCUMENTS_UPLOAD_POA_MANUAL,
                    payload: {
                        value: { content: null, name: null },
                        widgetID: 'frontSide',
                    },
                },
            },
            backSide: {
                titleLabel: 'Back side',
                ctaLabel: 'Upload',
                state: DocumentPickerState.DEFAULT,
                action: {
                    type: ACTION.SELECT_DOCUMENT,
                    routeId: ROUTE.CO_BORROWER_DOCUMENTS_UPLOAD_POA_MANUAL,
                    payload: {
                        value: { content: null, name: null },
                        widgetID: 'backSide',
                    },
                },
            },
            frontSideSpace: { size: SizeTypeTokens.XXXL },
            header: {
                title: 'Aadhaar Verification',
                type: HeaderTypeTokens.verification,
                stepperProps: {
                    data: stepper,
                    type: StepperTypeTokens.HORIZONTAL,
                },
                action: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.CO_BORROWER_DOCUMENTS_UPLOAD_POA_MANUAL,
                    payload: {},
                },
            },
            userDetails: {
                width: StackWidth.CONTENT,
                type: StackType.row,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                bgColor: ColorTokens.Warning_25,
                padding: {
                    left: SizeTypeTokens.MD,
                    right: SizeTypeTokens.MD,
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                },
                widgetItems: [
                    { id: 'userDetailsText', type: WIDGET.TEXT },
                    { id: 'userName', type: WIDGET.TEXT },
                ],
            },
            userDetailsText: {
                label: `Joint holder: `,
                color: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.XS,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                lineHeight: 16,
            },
            userName: {
                label: `${fullName}`,
                color: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.XS,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '700',
                lineHeight: 16,
            },
            spaceBeforeTitle: { size: SizeTypeTokens.MD },
            title: {
                label: `Upload joint holder's Aadhaar Card`,
                color: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.MD,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '700',
                lineHeight: 20,
            },
            spaceSubTitle: { size: SizeTypeTokens.LG },
            spaceSecondarySubTitle: { size: SizeTypeTokens.LG },
            spaceInput: { size: SizeTypeTokens.XL },
            subTitle: {
                label: 'Supported document formats : PDF/PNG/JPEG',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                lineHeight: 18,
            },
            secondarySubTitle: {
                label: 'File size < 5 MB',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                lineHeight: 18,
            },
            subTitleSpace: { size: SizeTypeTokens.XL },
            continue: {
                type: ButtonTypeTokens.LargeOutline,
                label: 'Confirm',
                width: ButtonWidthTypeToken.FULL,
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.MD,
                lineHeight: SizeTypeTokens.XXL,
                fontWeight: '700',
                action: {
                    type: ACTION.TRIGGER_CTA,
                    routeId: ROUTE.CO_BORROWER_DOCUMENTS_UPLOAD_POA_MANUAL,
                    payload: {},
                },
            },
            spaceContinue: { size: SizeTypeTokens.MD },
            stackBottom: {
                justifyContent: StackJustifyContent.center,
                alignItems: StackAlignItems.center,
                type: StackType.column,
                widgetItems: [{ id: 'continue', type: WIDGET.BUTTON }],
            },
            sbSpace1: { size: SizeTypeTokens.XL },
            sbSpace2: { size: SizeTypeTokens.MD },
            sbpace3: { size: SizeTypeTokens.MD },
        },
    };
};
export const coBorrowerDocumentUploadPOAManualMF = {
    onLoad: async ({ network }) => {
        const stepper = await horizontalStepperRepo(network);
        const application = (await SharedPropsService.getUser()).linkedApplications[0];
        const fullName = getCoBorrowerName(application.currentCoBorrowerAccountId, application.coBorrowerAccountMetaData);
        return Promise.resolve(template(stepper, fullName));
    },
    actions: {
        [ACTION.GO_BACK]: GoBackAction,
        [ACTION.SELECT_DOCUMENT]: documentPickerAction,
        [ACTION.ON_PAGE_LOAD]: onPageLoad,
        [ACTION.TRIGGER_CTA]: triggerAction,
    },
    clearPrevious: true,
    action: {
        type: ACTION.ON_PAGE_LOAD,
        routeId: ROUTE.CO_BORROWER_DOCUMENTS_UPLOAD_POA_MANUAL,
        payload: {},
    },
};
